<template>
	<div class="notice_popup poss">
		<div class="close">
			<img src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="tit">프로젝트 참여 설정</div>
		<div class="poss-bottom">
			<div class="selectlist">
				<div class="subtit">
					<p>참여 가능/불가능</p>	
				</div>
				<div class="subselect">
					<SelectComp type="radio" list="Y:참여 가능,N:참여 불가능"  v-model="joinPoss" defValue="Y" />
				</div>
			</div>

			<div class="selectlist">
				<div class="subtit">
					<p>참여 가능일</p>	
				</div>
				<div class="subselect">
					<SelectDate v-if="joinPoss=='N'" tagNm="div" type="date" class="select-box" classM="wd08" classD="wd08" to="Y3" title="일" rules="required" disabled/>
					<SelectDate v-else tagNm="div" v-model="joinPossYyyymmdd"  type="date" class="select-box" classM="wd08" classD="wd08" to="Y3" title="일" rules="required" />
					<p>부터</p>
				</div>
			</div>
		</div>
		<div class="poss-noti">
			<span> 위의 정보로 설정하시겠습니까? </span>
		</div>
		<div class="select-btn">
			<div class="btn" @click="$emit('close')">취소</div>
			<div class="btn" @click="setJoinPossDate()">예</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		param : Object,
	},
	
	data() {
		//현재 설정된 참여가능일을 초기값으로 표시한다.
		var joinPossYyyymmdd = (this.param.value || {}).joinPossYyyymmdd || null;
		return {
			data : this.param.value,
			tecMberSeq : this.param.tecMberSeq,
			isAdmin : this.param.admin == 'Y',
			joinPossYyyymmdd : joinPossYyyymmdd,
			joinPoss : joinPossYyyymmdd ? 'Y' : 'N',
		}
	},

	mounted() {
		//console.log('param', this.param);
	},

	methods : {
		setJoinPossDate() {
			//console.log('data', this.data);
			if(this.joinPossYyyymmdd == null && this.joinPoss == 'Y') {
				alert("날짜를 선택해주세요.");
				return;
			}

			var joinPossYyyymmdd = this.joinPoss == 'N' ? null : this.joinPossYyyymmdd;

			if(this.isAdmin) {
				//관리자가 대상 IT프로의 참여설정을 변경한다. (tecMberSeq 로 대상 지정, admin 여부는 서버가 JWT로 판별)
				var admParam = {
					tecMberSeq : this.tecMberSeq,
					joinPoss : this.joinPoss,
					joinPossYyyymmdd : joinPossYyyymmdd,
				}
				this.$.httpPost('/api/mem/prf/setPossState', admParam)
					.then(() => {
						alert('변경되었습니다.');
						//화면 전체를 새로고침하면 라우터 파라미터가 유실되므로 회원정보만 다시 조회한다.
						this.$emit('close', true);
					}).catch(this.$.httpErrorCommon);
			} else {
				var param = {
				mberSeq : this.$store.state.userInfo.mberSeq,
				joinPoss : this.joinPoss,
				joinPossYyyymmdd : joinPossYyyymmdd,

				}
				this.$.httpPost('/api/mem/prf/setPossState', param)
					.then(() => {
						alert('변경되었습니다.');
						this.$emit('close');
						this.$router.go(0);
					}).catch(this.$.httpErrorCommon);
			}

		},
	}
}
</script>

<style scoped>
.error {
	font-size: 80%;
	color:red;
	position : absolute;
    margin-left: 86px;
	width:200%;
}
</style>